import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

import { ref } from 'vue'
import { toRefs } from 'vue';

interface Props {
modelValue: any[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'pasteLiterature',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props;
const { modelValue } = toRefs(props);
const value = ref('')
const literatureValue = ref('')
const handlePaste = () => {
    console.log(value.value)
    literatureValue.value = value.value
}
const handleCheck = (e: any) => {
    console.log(e)
    if (e) {
        modelValue.value.push(literatureValue.value)
    } else {
        modelValue.value.splice(modelValue.value.indexOf(literatureValue.value), 1)
    }
    emit('update:modelValue', modelValue.value)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_input, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      placeholder: "文献信息",
      type: "textarea"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: handlePaste,
      class: "mt-[10px]"
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode(" 粘贴识别 ")
      ])),
      _: 1
    }),
    (literatureValue.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex justify-between border w-[100%] h-[65px] mb-[20px] p-[10px] rounded-sm", {
        'bg-[#e3eefb]': _unref(modelValue).includes(literatureValue.value),
        'border-[#409eff]': _unref(modelValue).includes(literatureValue.value)
    }])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, _toDisplayString(literatureValue.value), 1)
          ]),
          _createVNode(_component_el_checkbox, {
            label: "选择",
            size: "large",
            onChange: _cache[1] || (_cache[1] = (e) => handleCheck(e))
          })
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})